import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardBillingPYInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{width: "calc(-150px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>
          
          <Form
            id="CardBillingPYInterfaceUX-Form-49">
            <FormGroup
              id="CardBillingPYInterfaceUX-FormGroup-166"
              inline={true}
              style={{ marginBottom: "0px"}}>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-167"
                width={2}>
                <label
                  id="CardBillingPYInterfaceUX-label-179">
                  {props.languageUX === "en" ? "Creation Date" : "วันที่สร้าง"}
                </label>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-168"
                width={2}>
                <label
                  id="CardBillingPYInterfaceUX-label-178">
                  {props.languageUX === "en" ? "HN" : "HN"}
                </label>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-169"
                width={2}>
                <label
                  id="CardBillingPYInterfaceUX-label-177">
                  {props.languageUX === "en" ? "Receipt No" : "เลขที่ใบเสร็จ"}
                </label>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-170"
                width={2}>
                <label
                  id="CardBillingPYInterfaceUX-label-175">
                  {props.languageUX === "en" ? "Payment No" : "หมายเลขการชำระเงิน"}
                </label>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-171"
                width={2}>
                <label
                  id="CardBillingPYInterfaceUX-label-174">
                  {props.languageUX === "en" ? "Payment Id" : "รหัสการชำระเงิน"}
                </label>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-172"
                width={2}>
                <label
                  id="CardBillingPYInterfaceUX-label-173">
                  {"\u00A0"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardBillingPYInterfaceUX-FormGroup-93"
              inline={true}>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-105"
                width={2}>
                <div
                  id="CardBillingPYInterfaceUX-div-131"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardBillingPYInterfaceUX-DateTextBox-142"
                    onChange={props.onChangeDate}
                    value={props.searchBillingPY?.createDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-95"
                width={2}>
                <div
                  id="CardBillingPYInterfaceUX-div-132"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardBillingPYInterfaceUX-Input-143"
                    name="hn"
                    onChange={props.onChangeData}
                    value={props.searchBillingPY?.hn || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-96"
                width={2}>
                <div
                  id="CardBillingPYInterfaceUX-div-133"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardBillingPYInterfaceUX-Input-144"
                    name="receiptNo"
                    onChange={props.onChangeData}
                    value={props.searchBillingPY?.receiptNo || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-97"
                width={2}>
                <div
                  id="CardBillingPYInterfaceUX-div-134"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardBillingPYInterfaceUX-Input-145"
                    name="paymentNo"
                    onChange={props.onChangeData}
                    value={props.searchBillingPY?.paymentNo || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-98"
                width={2}>
                <div
                  id="CardBillingPYInterfaceUX-div-135"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardBillingPYInterfaceUX-Input-146"
                    name="paymentId"
                    onChange={props.onChangeData}
                    value={props.searchBillingPY?.paymentId || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingPYInterfaceUX-FormField-99"
                width={2}>
                <div
                  id="CardBillingPYInterfaceUX-div-136"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardBillingPYInterfaceUX-div-161"
                    style={{ display: "flex" }}>
                    
                    <div
                      id="CardBillingPYInterfaceUX-div-162"
                      style={{ margin: "0px 20px" }}>
                      
                      <div
                        id="CardBillingPYInterfaceUX-div-164">
                        {props.buttonSeach}
                      </div>
                    </div>
                    <div
                      id="CardBillingPYInterfaceUX-div-163">
                      
                      <Button
                        color="orange"
                        id="CardBillingPYInterfaceUX-Button-165"
                        onClick={props.onClickClear}>
                        {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                      </Button>
                    </div>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardBillingPYInterfaceUX-div-148">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.billingPYcolumns}
            data={props.billingPYData}
            id="CardBillingPYInterfaceUX-Table-154"
            minRows={5}
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          id="CardBillingPYInterfaceUX-div-149"
          style={{ display: "flex", justifyContent: "flex-end", margin: "20px 0px" }}>
          
          <div
            id="CardBillingPYInterfaceUX-div-150">
            
            <div
              id="CardBillingPYInterfaceUX-div-153">
              {props.buttonAdd}
            </div>
          </div>
          <div
            id="CardBillingPYInterfaceUX-div-151"
            style={{ margin: "0px 20px" }}>
            
            <div
              id="CardBillingPYInterfaceUX-div-152">
              {props.buttonEdit}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardBillingPYInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:45:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-150px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Form",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-Form-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormGroup",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormGroup-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-95"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-96"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-98"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-99"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-105"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 142,
      "name": "DateTextBox",
      "parent": 131,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-DateTextBox-142"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingPY?.createDate"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "Input",
      "parent": 132,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-Input-143"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingPY?.hn || \"\""
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Input",
      "parent": 133,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-Input-144"
        },
        "name": {
          "type": "value",
          "value": "receiptNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingPY?.receiptNo || \"\""
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Input",
      "parent": 134,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-Input-145"
        },
        "name": {
          "type": "value",
          "value": "paymentNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingPY?.paymentNo || \"\""
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "Input",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-Input-146"
        },
        "name": {
          "type": "value",
          "value": "paymentId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchBillingPY?.paymentId || \"\""
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-148"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", margin: \"20px 0px\" }"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-151"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEdit"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-152"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAdd"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-153"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 154,
      "name": "Table",
      "parent": 148,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.billingPYcolumns"
        },
        "data": {
          "type": "code",
          "value": "props.billingPYData"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-Table-154"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-163"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSeach"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-div-164"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Button",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-Button-165"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickClear"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormGroup",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormGroup-166"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-167"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-168"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-169"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-170"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-171"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-FormField-172"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "label",
      "parent": 172,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-label-173"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "label",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสการชำระเงิน",
          "valueEN": "Payment Id"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-label-174"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "label",
      "parent": 170,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขการชำระเงิน",
          "valueEN": "Payment No"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-label-175"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 169,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบเสร็จ",
          "valueEN": "Receipt No"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-label-177"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "label",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-label-178"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "label",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง",
          "valueEN": "Creation Date"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPYInterfaceUX-label-179"
        }
      },
      "seq": 179,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "CardBillingPYInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
